var utils = require('../../utils')

export default {
  name: 'reset-password',
  utils: utils,
  data: function () {
    return {
      password: null,
      password_retyped: null,
      isSuccess: false,
      message: null,
      showMessage: false
    }
  },
  created: function () {
    this.$store.dispatch('CLEAR_AUTH_STATUS')
  },
  computed: {
    isResetPasswordSuccess () {
      return (this.$store.getters.authStatus === 'success')
    },
    validRetypedPassword () {
      if (!utils.isBlank(this.password_retyped)) {
        return (this.password === this.password_retyped)
      }
      return true
    }
  },
  methods: {
    /** 送信可否 */
    canSubmit: function () {
      if (utils.isBlank(this.password) 
      || utils.isBlank(this.password_retyped)
      || utils.isBlank(this.$route.query.token)) {
        return false
      }
      if (this.password !== this.password_retyped) {
        return false
      }
      return true
    },

    /** パスワードリセット */
    reset: function () {
      this.showMessage = false
      var form = new FormData()
      form.append('password', this.password)
      form.append('token', this.$route.query.token)
      this.$store.dispatch('PASSWORD_RESET_UPDATE', {data: form})
      .then(
        (res) => {
          this.message = this.$t('reset_password.completed')
          this.showMessage = true
        },
        () => {
          this.message = this.$store.getters.authError || this.$store.getters.apiError
          this.showMessage = true
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/reset-password.js